import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function configOTP (otpType) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLogin)
      }, 500)
    })
  } else {
    const req = {
      url: 'api/login/configOTP',
      method: 'POST',
      data: {
        OTPType: otpType,
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { configOTP }
